import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Scroll to top on route change (fixes mobile sign-in opening mid-page). */
export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, search, hash]);

  return null;
}
